/**
 * Groups an array of objects by a specified key
 * @param array The array to group
 * @param key The key to group by
 * @returns An object with the grouped items
 */
export const groupBy = <T extends Record<K, any>, K extends keyof T>(array: T[], key: K): Record<T[K], T[]> => {
  return array.reduce(
    (result, currentValue) => {
      const groupKey = currentValue[key];
      (result[groupKey] = result[groupKey] || []).push(currentValue);
      return result;
    },
    {} as Record<T[K], T[]>
  );
};

/**
 * Safely access array elements with index
 * @param array The array to access
 * @param index The index to access
 * @returns The element at the index or undefined if out of bounds
 */
export const safeArrayAccess = <T>(array: T[], index: number): T | undefined => {
  return index >= 0 && index < array.length ? array[index] : undefined;
};
